import { Flex } from "@chakra-ui/react";
import { FaStar } from "react-icons/fa";
import colors from "common/theme/foundations/colors";

const Rating = ({ value = 0, onChange }) => {
  const numericValue = typeof value === "number" ? value : 0;

  return (
    <Flex>
      {[...Array(5)].map((_, index) => {
        const ratingValue = index + 1;
        return (
          <FaStar
            key={index}
            color={ratingValue <= numericValue ? colors.orange : colors.grey}
            size={24}
            style={{
              transition: "color 0.2s",
              cursor: onChange ? "pointer" : "default",
            }}
            onClick={onChange ? () => onChange(ratingValue) : undefined}
          />
        );
      })}
    </Flex>
  );
};


export default Rating;
